// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"7b930ce6","855":"3aacb07f"}[chunkId] + ".css";
};